import { api } from "@/lib/api";

/**
 * Knowledge retrieval for the support assistant.
 * Swap the implementation later (LLM/RAG) without changing SupportWidget.
 */
export async function retrieveAnswer(question, categoryId) {
  const payload = { question };
  if (categoryId) payload.category = categoryId;
  const res = await api.post("/support/ask", payload);
  return res.data;
}

export async function loadFaq() {
  const res = await api.get("/support/faq");
  return res.data;
}

export async function createSupportTicket({ category, subject, message, conversation }) {
  const res = await api.post("/support/tickets", {
    category,
    subject,
    message,
    conversation,
  });
  return res.data;
}

export async function fetchMyTickets() {
  const res = await api.get("/support/tickets/mine");
  return res.data || [];
}

export async function fetchAdminTickets() {
  const res = await api.get("/admin/support/tickets");
  return res.data || [];
}

export async function patchTicketStatus(ticketId, status) {
  const res = await api.patch(`/admin/support/tickets/${ticketId}`, { status });
  return res.data;
}
